/* eslint-disable import/prefer-default-export */
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";

export const getBusinessDashboard = (axiosOptions) =>
  caseTransformingAxios.get("/api/v4/reporting/business_dashboard", axiosOptions);
